import { render, staticRenderFns } from "./ViewGatGridSelection.vue?vue&type=template&id=0ce779f8&scoped=true&"
import script from "./ViewGatGridSelection.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce779f8",
  null
  
)

export default component.exports